import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const SettingsDashboard = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  if (!isAuthenticated) {
    return (
      <div className="page-container">
        <div className="page-content">
          <h2 style={{ fontSize: 18, margin: 0 }}>Settings</h2>
          <div>Please log in to view settings</div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="page-content">
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: 4 }}>
          <h2 style={{ fontSize: 18, margin: 0 }}>Settings</h2>
          <div style={{ display:'flex', gap:8, alignItems:'center' }} />
        </div>

        <div className="dashboard-section">
          <div className="dashboard-section-title">Manage</div>
          <div className="dashboard-grid">
            <div className="dashboard-card" onClick={() => navigate('/account')} style={{ cursor: 'pointer' }}>
              <h3>Account Settings</h3>
              <p>Profile, company info, users and roles</p>
            </div>
            <div className="dashboard-card" onClick={() => navigate('/configurations')} style={{ cursor: 'pointer' }}>
              <h3>Configurations</h3>
              <p>Number series, templates, item & tax settings</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsDashboard;


